import React from 'react';
import FancyButton from '../FancyButton';
import '../FancyButton.css';

type StatsButtonProps = {
  onClick: () => void;
};

const StatsButton: React.FC<StatsButtonProps> = ({ onClick }) => (
  <div title="View Player Statistics (Press 'S' key)">
    <FancyButton
      onClick={onClick}
      variant="blue"
      className="stats-button"
    >
      STATS
    </FancyButton>
  </div>
);

export default StatsButton;
